import jsPDF from "jspdf";
import "jspdf-autotable";
import { getLoggedUser } from "../../context/auth";
import CommonUtilities from "../Utilities/Common";
import {
  FIELD_TYPE_INTEGER,
  FIELD_TYPE_PERCENT,
  FIELD_TYPE_DECIMAL,
  FIELD_TYPE_CALCULATED,
  FIELD_TYPE_DROP_DOWN,
} from "../Utilities/Constant";
let loggedUser = {};
const GlobalConfig = new window.globalConfig();

export const handleExportPdf = async (e) => {
  window.showAlert("Info", "Exporting...", "info");

  try {
    loggedUser = getLoggedUser();
    const action = e.currentTarget.dataset.action;
    const dataRequest = {
      cropYearId: e.currentTarget.dataset.cropyearid,
      growerId: e.currentTarget.dataset.growerid,
      paymentId: e.currentTarget.dataset.paymentid,
      varietyId: e.currentTarget.dataset.varietyid
        ? e.currentTarget.dataset.varietyid
        : ``,
      createdUserId: loggedUser._id,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataRequest),
    };
    fetch(
      GlobalConfig.REACT_APP_API_GROWER_STATEMENT_URL + "exportpdf",
      requestOptions
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (resultObject) {
        if (resultObject && resultObject.result === "OK") {
          window.closeAllAlerts();
          if (
            resultObject.data === null ||
            resultObject.data === undefined ||
            resultObject.data.length <= 0
          ) {
            window.showAlert("Info", "There is no data to export.", "info");
          } else {
            composePdfFile(
              resultObject.data,
              action === "print",
              action === "preview",
              resultObject.processorName,
              resultObject.processorImage,
              resultObject.isRectangleLogo,
              resultObject.staticMessage
            );
          }
        }
        //If failed, show error
        else {
          window.showAlert("Error", resultObject.message, "error");
        }
      })
      .catch(function (error) {
        window.showAlert("Error", error, "error");
      });
  } catch (err) {
    window.showAlert("Error", err.message, "error");
  }
};

export const composePdfFile = (
  data,
  isPrint,
  isPreview,
  processorName,
  processorImage,
  isRectangleLogo,
  staticMessage
) => {
  if (data && data.length > 0) {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape
    const doc = new jsPDF(orientation, unit, size);

    let index = 1;
    data.map((u) => {
      let testType = {
        isDynamic: false,
        customfields: [],
      };
      if (u.testType) {
        testType = u.testType;
      }
      //Insert header
      composeHeader(
        u.growerInfo,
        doc,
        testType,
        processorImage,
        isRectangleLogo,
        true
      );
      // var res = doc.autoTableHtmlToJson(document.getElementById("tbl1"), true);
      // doc.autoTable(res.columns, res.data, {margin: {top: 80}});

      // var res2 = doc.autoTableHtmlToJson(document.getElementById("tbl2"), true);
      // doc.autoTable(res2.columns, res2.data, startY: doc.lastAutoTable.finalY + 20, {margin: {top: 80}});

      //Insert tables
      let tableFontSize = 9;
      let headerFontSize = 9;
      if (testType.isDynamic) {
        tableFontSize = 7;
        headerFontSize = 6.5;
      }
      const totalColumnWidth = composePaymentTable(
        u.itemsPayment,
        doc,
        tableFontSize,
        headerFontSize,
        testType
      );
      composeTaxFeeTable(
        u.itemsTaxFee,
        doc,
        tableFontSize,
        headerFontSize,
        testType,
        totalColumnWidth
      );
      composeOwnerTable(
        u.itemsOwner,
        doc,
        tableFontSize,
        headerFontSize,
        testType,
        totalColumnWidth
      );

      composeFooterStatementsInfo(processorName, u.growerInfo, doc);

      //Add grower statement message
      if (staticMessage && staticMessage.trim() !== ``) {
        doc.addPage();
        //Insert header
        composeHeader(
          u.growerInfo,
          doc,
          testType,
          processorImage,
          isRectangleLogo,
          false
        );
        addWrappedText({
          text: staticMessage,
          textWidth: doc.internal.pageSize.width + 90,
          doc,

          // Optional
          fontSize: "11",
          fontType: "normal",
          lineSpacing: 12, // Space between lines
          xPosition: 20, // Text offset from left of document
          initialYPosition: 120, // Initial offset from top of document; set based on prior objects in document
          pageWrapInitialYPosition: 12, // Initial offset from top of document when page-wrapping
        });
      }

      //Move to next grower
      if (index++ < data.length) {
        doc.addPage();
      }
    });

    const fileName =
      data[0].growerInfo.paymentDate.replace("/", "_") +
      "_" +
      data[0].growerInfo.growerName
        .replace(" ", "_")
        .replace("%20", "_")
        .toLowerCase() +
      "_" +
      data[0].growerInfo.paymentNo +
      ".pdf";
    //open popup print
    if (isPrint || isPreview) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        window.navigator.msSaveOrOpenBlob(doc.output("blob"), fileName);
      } else {
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        if (isPrint) {
          doc.autoPrint();
        }
        window.open(
          URL.createObjectURL(doc.output("blob")),
          "_blank",
          "height=" +
            window.innerHeight +
            ",width=" +
            window.innerWidth +
            ",scrollbars=yes,location=yes"
        );

        // For Firefox it is necessary to delay revoking the ObjectURL
        setTimeout(() => {
          window.URL.revokeObjectURL(doc.output("bloburl"));
        }, 100);
      }
    } else {
      //export file(s)
      const fileName =
        data[0].growerInfo.paymentDate.replace("/", "_").replace("_", "_") +
        "_" +
        data[0].growerInfo.growerName
          .replace(" ", "_")
          .replace("%20", "_")
          .toLowerCase() +
        "_" +
        data[0].growerInfo.paymentNo +
        ".pdf";
      doc.save(fileName);
    }
  }
};

function addWrappedText({
  text,
  textWidth,
  doc,
  fontSize = 10,
  fontType = "normal",
  lineSpacing = 7,
  xPosition = 10,
  initialYPosition = 10,
  pageWrapInitialYPosition = 10,
}) {
  var textLines = doc.splitTextToSize(text, textWidth); // Split the text into lines
  var pageHeight = doc.internal.pageSize.height; // Get page height, well use this for auto-paging
  // doc.setFontType(fontType);
  doc.setFontSize(fontSize);

  var cursorY = initialYPosition;

  textLines.forEach((lineText) => {
    if (cursorY > pageHeight) {
      // Auto-paging
      doc.addPage();
      cursorY = pageWrapInitialYPosition;
    }
    doc.text(xPosition, cursorY, lineText);
    cursorY += lineSpacing;
  });
}

function composeHeader(
  growerInfo,
  doc,
  testType,
  processorImage,
  isRectangleLogo,
  printGrowerInfo
) {
  doc.setFontSize(15);
  var growerName = growerInfo.growerName.toUpperCase();
  let xOffset =
    doc.internal.pageSize.width / 2 -
    (doc.getStringUnitWidth(growerName) * doc.internal.getFontSize()) / 2;
  doc.text(growerName, xOffset, 40);

  var title = "GROWER STATEMENT";
  xOffset =
    doc.internal.pageSize.width / 2 -
    (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) / 2;
  doc.text(title, xOffset, 60);

  const startX = testType.isDynamic ? 5 : 40;
  const startY = 130;
  doc.setFontSize(13);
  var subTitle = "CROP YEAR " + growerInfo.cropYear.toUpperCase();
  xOffset =
    doc.internal.pageSize.width / 2 -
    (doc.getStringUnitWidth(subTitle) * doc.internal.getFontSize()) / 2;
  doc.text(subTitle, xOffset, 80);

  if (printGrowerInfo === true) {
    doc.setFontSize(10);
    doc.text("Grower Account: " + growerInfo.growerName, startX, startY);
    doc.text("Payment No: " + growerInfo.paymentNo, startX, startY + 15);
    doc.text("Payment Date: " + growerInfo.paymentDate, startX, startY + 30);

    if (testType.basePriceByPayment !== true) {
      doc.text(
        "Payment %: " + growerInfo.paymentPercent + "%",
        startX,
        startY + 45
      );
      doc.text(
        "Total Percent: " + growerInfo.totalPaymentPercent + "%",
        startX + 160,
        startY + 45
      );
    }
  }

  doc.addImage(
    "data:image/png;base64,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",
    "png",
    30,
    20,
    140,
    60
  );
  if (processorImage && processorImage !== "") {
    let format = processorImage.split(";base64,")[0].split("data:image/")[1];
    if (isRectangleLogo) {
      doc.addImage(processorImage, format, 655, 20, 150, 75);
    } else {
      doc.addImage(processorImage, format, 655, 20, 150, 150);
    }
  }
}

function composeFooterStatementsInfo(processorName, growerInfo, doc) {
  const pages = doc.internal.getNumberOfPages();
  var growerName = growerInfo.growerName;
  if (pages) {
    const pageWidth = doc.internal.pageSize.width; //Optional
    const pageHeight = doc.internal.pageSize.height; //Optional
    doc.setFontSize(10); //Optional

    for (let j = 1; j < pages + 1; j++) {
      let horizontalPos = pageWidth / 2; //Can be fixed number
      let verticalPos = pageHeight - 10; //Can be fixed number
      doc.setPage(j);
      doc.text(
        `${processorName} Grower Statement for ${growerName}`,
        horizontalPos,
        verticalPos,
        {
          align: "center",
        }
      );
    }
  }
}

function composeFooter(doc) {
  const pages = doc.internal.getNumberOfPages();
  //Do not insert page number if there is only 1 page
  if (pages && pages > 1) {
    const pageWidth = doc.internal.pageSize.width; //Optional
    const pageHeight = doc.internal.pageSize.height; //Optional
    doc.setFontSize(10); //Optional

    for (let j = 1; j < pages + 1; j++) {
      let horizontalPos = pageWidth / 2; //Can be fixed number
      let verticalPos = pageHeight - 10; //Can be fixed number
      doc.setPage(j);
      doc.text("Page " + j + " of " + pages, horizontalPos, verticalPos, {
        align: "center",
      });
    }
  }
}

function composeSecondColumnsXPool(columns, columnStyles, tableFontSize) {
  columns.push({ header: "Process\nWeight", dataKey: "lbsDisplay" });
  columns.push({ header: "Regular\nPool %", dataKey: "regularPercent" });
  columns.push({ header: "Regular\nPool\nWeight", dataKey: "regularWeight" });
  columns.push({ header: "Price\nPer\nPound", dataKey: "regularPrice" });
  columns.push({ header: "XPool %", dataKey: "xpoolPercent" });
  columns.push({ header: "XPool\nWeight", dataKey: "xpoolWeight" });
  columns.push({ header: "Price\nPer\nPound", dataKey: "alternatePrice" });
  columns.push({ header: "Amount Due", dataKey: "amountDue" });
  columns.push({ header: "Payment", dataKey: "payment" });
  columns.push({ header: "YTD", dataKey: "ytd" });

  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 45,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 45,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 45,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 45,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 45,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 45,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 45,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 60,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 70,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 70,
  });
}

function composeSecondColumns(columns, columnStyles, tableFontSize, testType) {
  columns.push({ header: "LBS.", dataKey: "lbsDisplay" });
  if (testType.multiPricesSameLot !== true) {
    columns.push({ header: "$/LB.", dataKey: "lb" });
  }
  columns.push({ header: "PAYMENT", dataKey: "payment" });
  columns.push({ header: "YTD", dataKey: "ytd" });

  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 60,
  });
  if (testType.multiPricesSameLot !== true) {
    columnStyles.push({
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 60,
    });
  }
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 70,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 70,
  });
}

function composeSecondColumnsStatic(columns, columnStyles, tableFontSize) {
  columns = [
    { header: "LOT", dataKey: "lot" },
    { header: "DATE", dataKey: "date" },
    { header: "VARIETY", dataKey: "variety" },
    { header: "EDIBLE YIELD", dataKey: "edibleYield" },
    { header: "LBS.", dataKey: "lbsDisplay" },
    { header: "$/LB.", dataKey: "lb" },
    { header: "PAYMENT", dataKey: "payment" },
    { header: "YTD", dataKey: "ytd" },
  ];
  columnStyles = {
    0: {
      halign: "left",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 90,
    },
    1: {
      halign: "center",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 60,
    },
    2: {
      halign: "left",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
    },
    3: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 80,
    },
    4: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 80,
    },
    5: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 80,
    },
    6: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 80,
    },
    7: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 80,
    },
  };

  return { columns: columns, columnStyles: columnStyles };
}

function composePaymentTable(
  data,
  doc,
  tableFontSize,
  headerFontSize,
  testType
) {
  let totalColumnWidth = 0;
  if (data === null || data === undefined || data.length <= 0) {
    return totalColumnWidth;
  }
  let dataDisplay = [...data];
  dataDisplay.map((x) => {
    if (x.lb && x.lb !== ``) {
      x.lb = `$${CommonUtilities.numberWithCommas(
        parseFloat(
          x.lb
            .replace(`(`, ``)
            .replace(`)`, ``)
            .replace(`$`, ``)
            .replace(`,`, ``)
        ).toFixed(4)
      )}`;
    }
  });
  let margin;
  let columnStyles = [];
  let columns = [];
  if (testType.isDynamic) {
    margin = { top: 0, right: 5, bottom: 0, left: 5 };
    columns = [
      { header: testType.xpool ? "Raw\nLot #" : "LOT", dataKey: "lot" },
      { header: testType.xpool ? "Date" : "DATE", dataKey: "date" },
    ];
    columnStyles = [
      {
        halign: "left",
        fontSize: tableFontSize,
        lineColor: "gray",
        lineWidth: 0.1,
        cellWidth: 90,
      },
      {
        halign: "center",
        fontSize: tableFontSize,
        lineColor: "gray",
        lineWidth: 0.1,
        cellWidth: 50,
      },
    ];
    let existTextField = false;
    if (testType.customfields) {
      testType.customfields.map((f) => {
        columns.push({ header: f.name, dataKey: f.name });
        let align = "left";
        let cellWidth;
        if (f.fieldType) {
          switch (f.fieldType) {
            case FIELD_TYPE_INTEGER:
            case FIELD_TYPE_DECIMAL:
            case FIELD_TYPE_PERCENT:
            case FIELD_TYPE_CALCULATED:
              align = "right";
              cellWidth = 50;
              totalColumnWidth += cellWidth;
              break;
            case FIELD_TYPE_DROP_DOWN:
              cellWidth = 40;
              totalColumnWidth += cellWidth;
              break;
            default:
              existTextField = true;
              break;
          }
        } else {
          //static field
          existTextField = true;
        }
        columnStyles.push({
          halign: align,
          fontSize: tableFontSize,
          lineColor: "gray",
          lineWidth: 0.1,
          cellWidth: cellWidth,
        });
      });
    }
    if (testType.customfields && testType.customfields.length > 0) {
      if (existTextField) {
        totalColumnWidth = doc.internal.pageSize.getWidth() - 140 - 10;
      } else {
        totalColumnWidth += 210;
      }
    } else {
      totalColumnWidth = 260;
    }
    if (testType.xpool === true) {
      composeSecondColumnsXPool(columns, columnStyles, tableFontSize);
    } else {
      composeSecondColumns(columns, columnStyles, tableFontSize, testType);
    }
  } else {
    const obj = composeSecondColumnsStatic(
      columns,
      columnStyles,
      tableFontSize
    );
    columns = obj.columns;
    columnStyles = obj.columnStyles;
  }

  doc.autoTable({
    // styles: {
    //   fontSize: headerFontSize,
    //   columnWidth: "wrap"
    // },
    // tableWidth: "auto",
    margin: margin,
    startY: 185,
    // tableLineWidth: 0.1,
    // tableLineColor: "red",
    // head: columns,
    columns: columns,
    body: dataDisplay,
    headStyles: {
      // fillColor: [33, 150, 243],
      halign: "center",
      fontSize: headerFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
    },
    showHead: "everyPage",
    willDrawCell: function (data) {
      if (data.row.raw.lot === "Total") {
        doc.setFillColor("#bfbfbf");
        doc.setTextColor("black");
      }
    },
    columnStyles: columnStyles,
  });

  return totalColumnWidth;
}

function composeTaxFeeTable(
  data,
  doc,
  tableFontSize,
  headerFontSize,
  testType,
  totalColumnWidth
) {
  if (data === null || data === undefined || data.length <= 0) {
    return;
  }
  let lastCellWidth = 80;
  let margin;
  if (testType.isDynamic) {
    margin = { top: 0, right: 5, bottom: 0, left: 5 };
    lastCellWidth = 70;
  }
  const columns = [
    { header: "TAX & FEE", dataKey: "name" },
    { header: "", dataKey: "payment" },
    { header: "", dataKey: "ytd" },
  ];
  const columnStyles = {
    0: {
      halign: "left",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
    },
    1: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: lastCellWidth,
    },
    2: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: lastCellWidth,
    },
  };
  if (totalColumnWidth !== 0) {
    columnStyles[0].cellWidth = totalColumnWidth;
  }
  doc.autoTable({
    margin: margin,
    startY: doc.lastAutoTable.finalY,
    // tableLineWidth: 0.1,
    // tableLineColor: "red",
    // head: columns,
    columns: columns,
    body: data,
    headStyles: {
      // fillColor: [33, 150, 243],
      halign: "center",
      fontSize: headerFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
    },
    showHead: "everyPage",
    willDrawCell: function (data) {
      if (data.row.raw.name === "Net Payment") {
        doc.setFillColor("#bfbfbf");
        doc.setTextColor("black");
      }
    },
    columnStyles: columnStyles,
  });
}

function composeOwnerTable(
  data,
  doc,
  tableFontSize,
  headerFontSize,
  testType,
  totalColumnWidth
) {
  if (data === null || data === undefined || data.length <= 0) {
    return;
  }
  let splitCellWidth = 80;
  let lastCellWidth = 80;
  let margin;
  if (testType.isDynamic) {
    margin = { top: 0, right: 5, bottom: 0, left: 5 };
    splitCellWidth = 60;
    lastCellWidth = 70;
  }
  const columns = [
    { header: "PAYEE", dataKey: "name" },
    { header: "SPLIT %", dataKey: "ownerShip" },
    { header: "", dataKey: "payment" },
    { header: "", dataKey: "ytd" },
  ];
  const columnStyles = {
    0: {
      halign: "left",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
    },
    1: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: splitCellWidth,
    },
    2: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: lastCellWidth,
    },
    3: {
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: lastCellWidth,
    },
  };
  if (totalColumnWidth !== 0) {
    columnStyles[0].cellWidth = totalColumnWidth - 60;
  }
  doc.autoTable({
    margin: margin,
    startY: doc.lastAutoTable.finalY,
    columns: columns,
    body: data,
    styles: { overflow: "linebreak", columnWidth: "auto" },
    headStyles: {
      // fillColor: [33, 150, 243],
      halign: "center",
      fontSize: headerFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
    },
    showHead: "everyPage",
    // willDrawCell: function (data) {
    //   if (data.row.raw.name === "Net Payment") {
    //     doc.setFillColor("yellow");
    //   }
    // },
    columnStyles: columnStyles,
  });
}
